import { Outlet, useLocation } from "react-router-dom";
import { AppBreadcrumbs } from "@/shared/components/common/AppBreadcrumbs";
import type { ComponentType, ReactNode } from "react";

interface EntitySectionLayoutProps {
  basePath: string;
  HeaderComponent: ComponentType;
  hideHeaderMatchers?: string[];
  /** Optional content on the right of the breadcrumb row (e.g. a link to a related page). */
  breadcrumbAction?: ReactNode;
}

const DEFAULT_HIDE_MATCHERS = ["add", "edit/", "view-profile"] as const;

export function EntitySectionLayout({
  basePath,
  HeaderComponent,
  hideHeaderMatchers = [...DEFAULT_HIDE_MATCHERS],
  breadcrumbAction,
}: EntitySectionLayoutProps) {
  const location = useLocation();
  const hideHeader = hideHeaderMatchers.some((matcher) =>
    matcher.startsWith("/")
      ? location.pathname.includes(matcher)
      : location.pathname.includes(`${basePath}/${matcher}`),
  );

  return (
    <div className="flex flex-col gap-6">
      {breadcrumbAction ? (
        <div className="flex flex-wrap justify-between items-center gap-3">
          <AppBreadcrumbs />
          <div className="ml-auto">{breadcrumbAction}</div>
        </div>
      ) : (
        <AppBreadcrumbs />
      )}
      {hideHeader ? null : <HeaderComponent />}
      <div>
        <Outlet />
      </div>
    </div>
  );
}
